import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./container/home";
import ThankYou from "./container/ThankYou";

function AppRouter() {
  return (
    <div style={{}}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route exact path="/thank-you" component={ThankYou}></Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default AppRouter;
